import * as React from 'react';
const SvgDesigningImpactfulBranding = (props) => (
  <svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      clipPath="url(#designing-impactful-branding_svg__a)"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round">
      <path d="M112.262 99.165V44.907a7.482 7.482 0 0 0-7.484-7.484h-3.742M44.907 37.423h26.194M7.488 99.165V44.907a7.482 7.482 0 0 1 7.484-7.484h3.742M106.649 117.875H13.101c-6.198 0-11.226-5.028-11.226-11.226h44.903v3.742h26.194v-3.742h44.903c0 6.198-5.028 11.226-11.226 11.226ZM91.681 7.488l-9.354 20.58v63.917a5.308 5.308 0 0 0 5.308 5.31h8.088a5.308 5.308 0 0 0 5.309-5.31V28.07L91.677 7.488h.004ZM91.682 28.069h9.354M89.137 13.096h5.094M91.682 82.327h9.354M18.714 28.069h5.613" />
      <path d="M18.714 80.456V1.875h26.193v52.387M18.714 46.778h5.613M18.714 63.617h5.613M72.972 64.211l-13.097-13.69-41.161 43.031h54.258" />
      <path d="M46.778 82.327h26.194L59.875 69.23 46.778 82.327Z" />
    </g>
    <defs>
      <clipPath id="designing-impactful-branding_svg__a">
        <path fill="#fff" d="M0 0h120v120H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgDesigningImpactfulBranding;
